import { css } from 'styled-components';

const LinkButtonStyle = css `
    text-decoration: none;
`;

export { LinkButtonStyle };
//# sourceMappingURL=LinkButton.styles.js.map
